import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { UiLoginHelper } from '../helpers/UiLoginHelper';

export class NumericOTPInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth >
        {/* <InputLabel htmlFor='SECURITY CODE'>SECURITY CODE</InputLabel> */}
        <Input {...this.props} type='password' />
      </FormControl>
    )
  }
}

export class PasswordInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth >
        {/* <InputLabel htmlFor='password'>{this.props.inputLabel ? this.props.inputLabel : 'Enter your password' }</InputLabel> */}
        <Input {...this.props} type='password' />
      </FormControl>
    )
  }
}

export class UsernameInput extends Component {
  constructor(props) {
    super(props);
    this.userNameType = this.props.userNameType
  }

  render() {
    return (
      <FormControl fullWidth >
        {/* {this.userNameType === UiLoginHelper.UserNameType.PHONE ?
          <InputLabel htmlFor='mobile-number'>Enter mobile number</InputLabel>
          :
          <InputLabel htmlFor='email'>Enter your email</InputLabel>
        } */}
        <Input {...this.props} />
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/TextInputs.js